import React, { ReactNode } from "react";
import { StyledAppsHeader } from "./index.styled";
import useScreen from "@lib/hooks/useScreen";

type AppsHeaderProps = {
  children: ReactNode;
  bg?: "primary" | "secondary";
};

const AppsHeader: React.FC<AppsHeaderProps> = ({
  children,
  bg = "secondary",
}) => {
  const { isMobile } = useScreen();

  return (
    <StyledAppsHeader mobile={isMobile} bg={bg}>
      {children}
    </StyledAppsHeader>
  );
};

export default AppsHeader;
